// extracted by mini-css-extract-plugin
export default {"mobile_side":"Store_mobile_side__Q89xA","final_gridd":"Store_final_gridd__Ffxn-"};